module.exports = __webpack_public_path__ + "static/media/tryForkBase.8c6dc0d7.png";